import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EntityListView } from '@/components/EntityListView';
import { roleListService } from '@/services/identity/roleListService';
import { buildRoleListColumns } from '@/core/RoleListColumns';

/**
 * The Roles grid, on the same <EntityListView> shell as the generated entity lists: saved views,
 * column filters, bulk delete and keyboard navigation come from the shell. Roles are ABP's
 * IdentityRole rather than a DSL entity, so the columns are hand-written and the list reads
 * /api/identity/role-list (see roleListService). Deleting a static role is refused by ABP on the
 * server and surfaces in the error banner.
 */
export function RoleListPage() {
  const { t } = useTranslation();
  const columns = useMemo(() => buildRoleListColumns(t), [t]);

  return (
    <EntityListView
      module="Core"
      entity="Role"
      service={roleListService}
      columns={columns}
      gridKey="Core:Role"
      titleKey="identity.roles"
      title="Roles"
      basePath="/core/roles"
      defaultSort={[{ field: 'name', sort: 'asc' }]}
      rowGroupingEnabled={false}
    />
  );
}
